import requist from "./axios";

//
export const sendCode = form => {
  return requist.post("/v1/verification/send_code/", form);
};
// 
export const regist = form => {
  return requist.post("/v2/users/", form);
};
//
export const checkPhone = form => {
  return requist.get("/v1/users/check/", { params: form });
};
//
export const login = form => {
  return requist.post("/v2/login/", form);
};
